<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps<{ hand?: string; side?: string }>()
const { t } = useI18n()
</script>

<template>
  <div class="grid gap-4 sm:grid-cols-2">
    <label class="form-control"><span class="label-text mb-2 font-bold">{{ t('player.profile.hand') }}</span>
      <select class="select select-bordered" name="preferred_hand" :value="hand"><option value="">—</option><option value="RIGHT">{{ t('player.profile.right') }}</option><option value="LEFT">{{ t('player.profile.left') }}</option></select>
    </label>
    <label class="form-control"><span class="label-text mb-2 font-bold">{{ t('player.profile.side') }}</span>
      <select class="select select-bordered" name="preferred_side" :value="side"><option value="">—</option><option value="RIGHT">{{ t('player.profile.right') }}</option><option value="LEFT">{{ t('player.profile.left') }}</option><option value="BOTH">{{ t('player.profile.both') }}</option></select>
    </label>
  </div>
</template>
